import { Direccion, Pais } from "./direccion";
import { Contacto } from "./contacto";
import { TipoCliente } from "../forms/clientes/tipos-cliente/tipo-cliente/tipo-cliente";
import { ArchivoEntidad } from "./archivo-entidad";

export interface TipoEntidad {
  IdTipo: number | string;
  descripcion: string;
}

export class Entidad {
  constructor(
    public IdEntidad: number | string = '',
    public razonSocial: string = '',
    public nombreFantasia: string = '',
    public nombre: string = '',
    public apellido: string = '',
    public cargo: string = '',
    public dia_nacimiento: string = null,
    public mes_nacimiento: string = null,
    public telefonoPrincipal: string = '',
    public telefonoPrincipalCodigoPais: string = '',
    public telefonoPrincipalCodigoArea: string = '',
    public telefonoPrincipalNumero: string = '',
    public telefonoMovil: string = '',
    public telefonoMovilCodigoPais: string = '',
    public telefonoMovilCodigoArea: string = '',
    public telefonoMovilNumero: string = '',
    public cuit: string = null,
    public fechaContacto: string = null,
    public direccion: Direccion = <Direccion>{
      pais: <Pais>{},
      provincia: '',
      localidad: '',
      codigoPostal: '',
      calle: '',
      numero: null,
      piso: '',
      departamento: '',
    },
    public fechaModificacion: string = null,
    public VIP?: boolean,
    public tipoEntidad?: TipoEntidad,
    public IdExtranet?: number | string,
    public contactos: Contacto[] = <Contacto[]>[],
    public created_by: string = '',
    public tipoCliente?: TipoCliente,
    public archivoEntidad: ArchivoEntidad[] = <ArchivoEntidad[]>[],
    public referencia?: string,
    public esCliente: boolean = false,
    public observacion: string = '',
    public redSocial1: string = '',
    public redSocial2: string = '',
    public paginaWeb: string = '',
    public direccionFacturacion: string = '',
    public IdTango: string = '',
    public condicionVenta: string = '',
    public porcentajeBonificacion: string = '',
    public transporte: string = '',
    public certificacion: string = '',
    public fechaCertificacion: string = null,
    public pago: string = '',
    public examen: string = '',
    public kit: string = '',
    public perfil: string = '',
    public email: string = '',
    public origen:any='',
    public ultimaModificacion: string = '',
    public fechaCreacion: string = ''
  ) { }
}
